import { render, staticRenderFns } from "./drawer-user-group-edit.vue?vue&type=template&id=28b29537&"
import script from "./drawer-user-group-edit.vue?vue&type=script&lang=js&"
export * from "./drawer-user-group-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports